module.exports = __webpack_public_path__ + "static/media/arrow_down_dark.09490b73.svg";